module.exports = __webpack_public_path__ + "img/c07_buildingstartechnetlandline_Normal_ua.1b88a0b1.webp";